const parliamentaryAreas: string[] = ['Kangra', 'Market', 'Hamirpur', 'Shimla']

export default parliamentaryAreas
